import { createSelector } from 'reselect'

const getBounds = state => {
  return state.timestamp.bounds
}

const getDatetimeFunction = (state, datetimeFunction) => {
  return datetimeFunction
}

const defaultTime = () => {
  const tmin = new Date(
    new Date().setFullYear(new Date().getFullYear() - 10)
  ).toISOString()
  const tmax = null

  return { tmin, tmax }
}

export const getViewparams = createSelector(
  [getBounds, getDatetimeFunction],
  (bounds, datetimeFunction) => {
    if (!bounds || bounds.length === 0) {
      return null
    }
    const { tmin } = defaultTime()
    const viewparams = `tmin:${tmin};xmin:${bounds[0][0]};ymin:${
      bounds[0][1]
    };xmax:${bounds[1][0]};ymax:${bounds[1][1]};`

    return viewparams
  }
)



// WEBPACK FOOTER //
// ./src/selectors/viewparamsSelector.js